import { Component, input, output } from '@angular/core';

@Component({
  selector: 'lib-select-input',
  templateUrl: './select-input.component.html',
  styleUrl: './select-input.component.scss',
})
export class SelectInputComponent {
  public readonly inputId = input<string>();

  public readonly value = input<string>();

  public readonly changed = output<string>();

  applyValue(event: Event): void {
    this.changed.emit((event.target as HTMLSelectElement).value);
  }
}
